import { useEffect, useState } from "react";
import { Menu, X, Instagram } from "lucide-react";
import { LOGO_URL, INSTAGRAM_URL, waLink } from "../../lib/constants";

const LINKS = [
  { label: "Home", href: "#home" },
  { label: "Sobre", href: "#sobre" },
  { label: "O Que É?", href: "#oquee" },
  { label: "Diagnóstico e Tratamento", href: "#diagnostico" },
  { label: "Depoimentos", href: "#depoimentos" },
  { label: "Convênios", href: "#convenios" },
  { label: "FAQ", href: "#faq" },
  { label: "Contato", href: "#contato" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 w-full z-40 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur-md shadow-sm border-b border-gray-100"
          : "bg-white/70 backdrop-blur-sm"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 lg:px-8 flex items-center justify-between h-20">
        <a href="#home" className="flex items-center gap-3" data-testid="header-logo">
          <img
            src={LOGO_URL}
            alt="Logotipo Dr. Mateus Marques - Cirurgião Torácico"
            className="h-12 w-auto"
            width="48"
            height="48"
          />
          <div className="leading-tight hidden sm:block">
            <div className="font-poppins font-bold text-sm text-[#0D47A1]">Dr. Mateus Marques</div>
            <div className="text-[11px] text-[#212121]/55">Cirurgião Torácico · CRM-BA 28.632</div>
          </div>
        </a>

        <nav className="hidden xl:flex items-center gap-5">
          {LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-${link.href.replace("#", "")}`}
              className="text-sm font-semibold text-[#212121]/70 hover:text-[#0D47A1] transition-colors"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-instagram"
            aria-label="Instagram do Dr. Mateus Marques"
            className="hidden sm:inline-flex w-10 h-10 items-center justify-center rounded-full text-[#0D47A1] hover:bg-[#0D47A1]/10 transition-colors"
          >
            <Instagram size={20} />
          </a>
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-cta-agendar"
            className="hidden md:inline-flex items-center gap-2 bg-[#0D47A1] hover:bg-[#00897B] text-white font-poppins font-semibold text-sm px-5 py-2.5 rounded-full transition-colors duration-200 shadow-md hover:-translate-y-0.5"
          >
            AGENDAR CONSULTA
          </a>
          <button
            className="xl:hidden w-10 h-10 flex items-center justify-center text-[#0D47A1]"
            onClick={() => setOpen((o) => !o)}
            aria-label="Abrir menu"
            data-testid="header-mobile-toggle"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="xl:hidden bg-white border-t border-gray-100 shadow-md" data-testid="mobile-menu">
          <nav className="max-w-7xl mx-auto px-4 py-4 flex flex-col gap-1">
            {LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${link.href.replace("#", "")}`}
                className="py-3 px-2 text-sm font-semibold text-[#212121]/80 hover:text-[#0D47A1] hover:bg-[#EEF4FF] rounded-lg transition-colors"
              >
                {link.label}
              </a>
            ))}
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setOpen(false)}
              data-testid="mobile-instagram"
              className="py-3 px-2 text-sm font-semibold text-[#212121]/80 hover:text-[#0D47A1] hover:bg-[#EEF4FF] rounded-lg transition-colors flex items-center gap-2"
            >
              <Instagram size={18} /> Instagram
            </a>
            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setOpen(false)}
              data-testid="mobile-cta-agendar"
              className="mt-2 inline-flex items-center justify-center gap-2 bg-[#0D47A1] text-white font-poppins font-bold text-sm px-5 py-3 rounded-full"
            >
              AGENDAR CONSULTA
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
